import { useTranslation } from "react-i18next";
import { useAnimatedNumber } from "../../../hooks/useAnimatedNumber";
import { useState, useEffect } from "react";

interface AnimatedChangeRowProps {
  name: string;
  power: { original: number; afterTuning: number; difference: number };
  torque: { original: number; afterTuning: number; difference: number };
  shouldAnimate: boolean; // управляем извне
}

const AnimatedChangeRow: React.FC<AnimatedChangeRowProps> = ({
  name,
  power,
  torque,
  shouldAnimate,
}) => {
  const { t } = useTranslation();

  // Анимированные значения
  const animatedPowerAfter = useAnimatedNumber(
    power.afterTuning - power.original,
    1000,
    shouldAnimate
  ) + power.original;

  const animatedTorqueAfter = useAnimatedNumber(
    torque.afterTuning - torque.original,
    800,
    shouldAnimate
  ) + torque.original;

  const animatedPowerDiff = useAnimatedNumber(power.difference, 800, shouldAnimate);
  const animatedTorqueDiff = useAnimatedNumber(torque.difference, 800, shouldAnimate);

  return (
    <div className="max-w-screen-2xl w-full place-self-center max-md:p-4 sm:p-2">
      <div className="rounded-xl bg-content3 overflow-hidden">
        <table className="w-full">
          <thead className="bg-tablebg2">
            <tr>
              <th className="w-1/6 text-left md:p-5 max-md:p-3 text-primary font-normal border border-tableline">
                {name}
              </th>
              <th className="w-1/4 text-left md:p-5 max-md:p-3 text-textsecondary font-normal border border-tableline">
                {t("Original")}
              </th>
              <th className="w-1/4 text-left md:p-5 max-md:p-3 text-textsecondary font-normal border border-tableline">
                {t("After tuning")}
              </th>
              <th className="w-1/4 text-left md:p-5 max-md:p-3 text-textsecondary font-normal border border-tableline">
                {t("Difference")}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th className="text-left md:p-5 max-md:p-3 text-textsecondary font-normal border border-tableline bg-tablebg2">
                {t("Power")}
              </th>
              <td className="md:p-5 max-md:p-3 border border-tableline">
                {power.original}
              </td>
              <td className="md:p-5 max-md:p-3 border border-tableline font-semibold">
                {Math.round(animatedPowerAfter)}
              </td>
              <td className="md:p-5 max-md:p-3 border border-tableline font-bold text-success">
                + {Math.round(animatedPowerDiff)}
                <span aria-hidden="true" className="ml-1">
                  ↑
                </span>
              </td>
            </tr>
            <tr>
              <th className="text-left md:p-5 max-md:p-3 text-textsecondary font-normal border border-tableline bg-tablebg2">
                {t("Torque")}
              </th>
              <td className="md:p-5 max-md:p-3 border border-tableline">
                {torque.original}
              </td>
              <td className="md:p-5 max-md:p-3 border border-tableline font-semibold">
                {Math.round(animatedTorqueAfter)}
              </td>
              <td className="md:p-5 max-md:p-3 border border-tableline font-bold text-success">
                + {Math.round(animatedTorqueDiff)}
                <span aria-hidden="true" className="ml-1">
                  ↑
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AnimatedChangeRow;